/**
 * Component: Sticky Filters
 * ------------------------------------------------------------------------------
 * A sticky Boost filter feature on desktop and mobile.
 *
 * @namespace stickyFilters
 */
import cssClasses from '~/helpers/cssClasses';
import {throttle, on} from '~/helpers/utils';

/**
 * DOM selectors.
 */
const selectors = {
  headerContainer: '[js-site-header="wrapper"]',
  collectionFilters: '.template-collection__tools-container',
};

/**
 * Create a new sticky filter object.
 */
export default () => {

  /**
   * DOM node selectors.
   */
  const nodeSelectors = {
    headerContainer: document.querySelector(selectors.headerContainer),
    collectionFilters: document.querySelector(selectors.collectionFilters),
  };

  let scrollDirection = 'down';
  let previousScrollPosition = 0;

  /**
   * Initialise component.
   */
  function init() {
    handleScroll();
    setEventListeners();
  }

  /**
   * Event listeners.
   */
  function setEventListeners() {
    on('scroll', throttle(() => handleScroll(), 250));
  }


  /**
   * Handle scroll event.
   */
  function handleScroll() {
    updateScrollPositionAndDirection();
    Filters();
  }

  /**
   * Store scroll direction and position in memory.
   * Checks current scroll position against previous to determine direction.
   */
  function updateScrollPositionAndDirection() {
    if (window.scrollY > previousScrollPosition) {
      scrollDirection = 'down';
    } else {
      scrollDirection = 'up';
    }
    previousScrollPosition = window.scrollY;
  }

  /**
   * Get offset value for sticky header.
   * - Checks scroll position to account for collapsed site header.
   * @returns {Number} - offset value for sticky filter
   */
  function getStickyFilterOffset() {
    if (scrollDirection === 'up' && !nodeSelectors.headerContainer.classList.contains('is-collapsed')) {
      return nodeSelectors.headerContainer.offsetHeight;
    }

    return 0;
  }

  /**
   * Checks page position on scroll at desktop and adds class and css where
   * necessary to hold filter under header.
   */
  function Filters() {
    if (window.scrollY >= 565) {
      const offset = getStickyFilterOffset();
      nodeSelectors.collectionFilters.classList.add(cssClasses.sticky);
      nodeSelectors.collectionFilters.style.transform =
       `translateY(${offset}px)`;
      return;
    }

    if (window.scrollY >= 655) {
      const offset = getStickyFilterOffset();
      nodeSelectors.collectionFilters.classList.add(cssClasses.sticky);
      nodeSelectors.collectionFilters.style.transform =
        `translateY(${offset - 1}px)`;
      return;
    }

    nodeSelectors.collectionFilters.classList.remove(cssClasses.sticky);
    nodeSelectors.collectionFilters.style.transform = 'translateY(0)';
  }


  /**
   * Expose public interface.
   */
  return Object.freeze({
    init,
  });
};
